var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"password-meter rounded-b absolute h-1 overflow-hidden",class:`meter-${_vm.strength}`})
}
var staticRenderFns = []

export { render, staticRenderFns }